<template>
  <div id="app">
    <div class="update-main">
      <!-- ── Topbar ── -->
      <div class="update-topbar">
        <div class="update-topbar__left">
          <button class="update-btn-back" @click="volver()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <line
                x1="19"
                y1="12"
                x2="5"
                y2="12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
              <polyline
                points="12,19 5,12 12,5"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                fill="none"
              />
            </svg>
            Volver
          </button>
        </div>
        <div class="update-topbar__center">
          <h1 class="update-topbar__title">
            {{ tConfirm("messages.editJob") }}
          </h1>
          <div class="update-topbar__subtitle" v-if="order">
            #{{ order.id }} · {{ order.orderNumber }}
          </div>
        </div>
        <div class="update-topbar__actions">
          <button class="update-btn-primary" @click="modifyOrder">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <polyline
                points="20,6 9,17 4,12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                fill="none"
              />
            </svg>
            {{ tButton("modify") }}
          </button>
        </div>
      </div>

      <!-- ── Cuerpo con scroll ── -->
      <div class="update-body" v-if="order">
        <!-- ── Card campos principales ── -->
        <div class="update-card">
          <div class="update-card__header">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path
                d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"
                stroke="#0284C7"
                stroke-width="2"
                stroke-linecap="round"
              />
              <path
                d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"
                stroke="#0284C7"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
            <span class="update-card__title">Datos principales</span>
          </div>

          <el-form ref="form" :model="order" class="update-form">
            <div class="update-fields-grid">
              <!-- Fila 1: Nº Orden | Carretilla -->
              <div class="update-field">
                <label class="update-field__label">{{
                  tField("orderNumber")
                }}</label>
                <el-input
                  v-model="order.orderNumber"
                  class="update-input"
                  :placeholder="tPlaceholder('orderNumber')"
                />
              </div>

              <div class="update-field">
                <label class="update-field__label">{{
                  tField("recorderName")
                }}</label>
                <el-select
                  v-model="order.recorderId"
                  class="update-input"
                  :placeholder="tPlaceholder('recorderName')"
                  clearable
                >
                  <el-option
                    v-for="f in valoresCarretillas"
                    :key="f.id"
                    :label="f.name"
                    :value="f.id"
                  />
                </el-select>
              </div>

              <!-- Fila 2: Hora inicio | Hora fin -->
              <div class="update-field">
                <label class="update-field__label">{{
                  tField("videoStart")
                }}</label>
                <el-date-picker
                  v-model="order.videoStart"
                  type="datetime"
                  class="update-input"
                  :placeholder="tPlaceholder('startDay')"
                />
              </div>

              <div class="update-field">
                <label class="update-field__label">{{
                  tField("videoEnd")
                }}</label>
                <el-date-picker
                  v-model="order.videoEnd"
                  type="datetime"
                  class="update-input"
                  :placeholder="tPlaceholder('finishTime')"
                />
              </div>
            </div>
          </el-form>
        </div>

        <!-- ── Card atributos adicionales ── -->
        <div
          class="update-card"
          v-if="
            (additionalAttributes && additionalAttributes.length) ||
            orderTypes.length
          "
        >
          <el-collapse
            v-model="activeNames"
            @change="handleChange"
            class="update-collapse"
          >
            <el-collapse-item name="1">
              <template slot="title">
                <div class="update-collapse__title">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <circle
                      cx="12"
                      cy="12"
                      r="3"
                      stroke="#0284C7"
                      stroke-width="2"
                      fill="none"
                    />
                    <path
                      d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"
                      stroke="#0284C7"
                      stroke-width="2"
                      fill="none"
                    />
                  </svg>
                  <span>{{ tField("addicional") }}</span>
                </div>
              </template>

              <div class="update-fields-grid update-fields-grid--additional">
                <div
                  class="update-field"
                  v-for="field in additionalAttributes"
                  :key="field"
                >
                  <label class="update-field__label">{{ tField(field) }}</label>
                  <el-input
                    v-model="order[field]"
                    class="update-input"
                    :placeholder="tPlaceholder(field)"
                  />
                </div>

                <!-- Type -->
                <div class="update-field" v-if="orderTypes.length">
                  <label class="update-field__label">{{
                    tField("type")
                  }}</label>
                  <el-select
                    v-model="order.type"
                    class="update-input"
                    :placeholder="tPlaceholder('type')"
                    clearable
                  >
                    <el-option
                      v-for="t in orderTypes"
                      :key="t"
                      :label="t"
                      :value="t"
                    />
                  </el-select>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>

        <!-- ── Footer actions (móvil) ── -->
        <div class="update-footer-actions">
          <button class="update-btn-primary" @click="modifyOrder">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <polyline
                points="20,6 9,17 4,12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                fill="none"
              />
            </svg>
            {{ tButton("modify") }}
          </button>
        </div>
      </div>
      <!-- /update-body -->

      <!-- Estado de carga -->
      <div v-else class="update-loading">
        <i class="el-icon-loading" style="font-size: 24px; color: #0284c7"></i>
        <span>Cargando orden…</span>
      </div>
    </div>
  </div>
</template>

<script>
import ordersApi from "@/services/orders.api";
import storage from "@/components/utils/storage";
import config from "@/../public/config.json";

export default {
  name: "OrderUpdate",

  data() {
    return {
      order: null,
      valoresCarretillas: [],
      activeNames: [""],
      orderTypes: [],
    };
  },
  computed: {
    group() {
      return typeof storage.loadGroup === "function"
        ? storage.loadGroup()
        : storage.loadGroup;
    },
    tField() {
      return (key) => this.$t(`main.jobs.fields.${key}`);
    },
    tPlaceholder() {
      return (key) => this.$t(`main.jobs.placeholders.${key}`);
    },
    tButton() {
      return (key) => this.$t(`main.jobs.buttons.${key}`);
    },
    tConfirm() {
      return (key) => this.$t(`main.jobs.${key}`);
    },
    additionalAttributes() {
      return Array.isArray(config.additionalAttributes)
        ? config.additionalAttributes
        : [];
    },
  },
  created() {
    this.fetchOrder(), this.fetchCarretillas(), this.getOrderTypes();
  },

  methods: {
    async getOrderTypes() {
      try {
        this.orderTypes = await ordersApi.getTypes();
      } catch (err) {
        console.error(err);
        this.orderTypes = [];
      }
    },
    async fetchOrder() {
      try {
        const id = this.$route.params.id;
        const response = await ordersApi.fetchById(id);
        this.order = response.data;
      } catch (error) {
        console.error("Error al cargar la orden:", error);
      }
    },
    async fetchCarretillas() {
      try {
        const resp = await ordersApi.getrecorders();
        console.log("recorders raw:", resp);
        this.valoresCarretillas = resp.map((recorder) => ({
          id: recorder.identifier,
          name: recorder.name,
        }));
      } catch (e) {
        console.error("Error cargando carretillas:", e);
      }
    },

    volver() {
      this.$router.go(-1);
    },

    async submitForm() {
      const id = this.$route.params.id;
      await ordersApi.updateById(id, this.order);
      this.$message.success(this.$t("main.jobs.messages.modifySuccess"));
      this.volver();
    },
    modifyOrder() {
      this.$confirm(this.$t("main.jobs.messages.confirmModifyOrder"), {
        confirmButtonText: this.$t("main.jobs.buttons.confirm"),
        cancelButtonText: this.$t("main.jobs.buttons.cancel"),
        type: "warning",
      })
        .then(async () => {
          try {
            await this.submitForm();
          } catch (err) {
            console.error("Error modificando orden:", err);
            if (err.response?.status === 403) {
              this.$message.error(this.$t("main.jobs.messages.noPermission"));
            } else if (err.response?.status === 404) {
              this.$message.error(this.$t("main.jobs.messages.orderNotFound"));
            } else {
              this.$message.error(this.$t("main.jobs.messages.modifyError"));
            }
          }
        })
        .catch(() => {
          this.$message.info(this.$t("main.jobs.messages.modifyCancelled"));
        });
    },
  },
};
</script>

<style>
/* ── Layout ───────────────────────────────────────────────────── */
.update-main {
  padding: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* crece con el contenido */
  background: #f0f4f8;
}

/* ── Topbar ───────────────────────────────────────────────────── */
.update-topbar {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07);
  padding: 13px 22px;
  position: sticky;
  top: 0;
  z-index: 10;
}

.update-topbar__left {
  flex-shrink: 0;
}

.update-topbar__center {
  flex: 1;
}

.update-topbar__title {
  margin: 0;
  font-size: 19px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.2;
}

.update-topbar__subtitle {
  margin-top: 2px;
  font-size: 11px;
  color: #64748b;
}

.update-topbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

/* Back button */
.update-btn-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 6px 12px;
  cursor: pointer;
  color: #64748b;
  font-size: 12px;
  font-family: inherit;
  transition: border-color 0.15s, color 0.15s;
}
.update-btn-back:hover {
  border-color: #0284c7;
  color: #0284c7;
}

/* Primary button */
.update-btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #0284c7;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 8px 18px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  box-shadow: 0 2px 8px rgba(2, 132, 199, 0.35);
  transition: background 0.15s, box-shadow 0.15s;
}
.update-btn-primary:hover {
  background: #0369a1;
  box-shadow: 0 4px 12px rgba(2, 132, 199, 0.45);
}

/* ── Scrollable body ──────────────────────────────────────────── */
.update-body {
  padding-bottom: 24px; /* breathing room at bottom */
  overflow: visible;
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Loading state ────────────────────────────────────────────── */
.update-loading {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #64748b;
  font-size: 13px;
}

/* ── Cards ────────────────────────────────────────────────────── */
.update-card {
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.update-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.update-card__title {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}

/* ── Form & fields grid ───────────────────────────────────────── */
.update-form {
  padding: 20px;
}

.update-fields-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px 28px;
}

.update-fields-grid--additional {
  padding: 16px 20px 20px;
}

.update-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.update-field__label {
  font-size: 11px;
  font-weight: 600;
  color: #0284c7;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

/* Make el-input, el-select, el-date-picker fill the cell */
.update-input,
.update-input .el-input,
.update-input .el-input__inner {
  width: 100% !important;
}

.update-input .el-input__inner {
  border-color: #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  color: #0f172a;
  height: 38px;
  transition: border-color 0.15s;
}
.update-input .el-input__inner:focus {
  border-color: #0284c7;
}
.update-input .el-input__inner::placeholder {
  color: #94a3b8;
}

/* ── Collapse ─────────────────────────────────────────────────── */
.update-collapse {
  border: none !important;
}

.update-collapse .el-collapse-item__header {
  padding: 12px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0 !important;
  border-top: none !important;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  height: auto;
  line-height: 1.4;
}

.update-collapse .el-collapse-item__wrap {
  border-bottom: none !important;
}

.update-collapse .el-collapse-item__content {
  padding: 0;
}

.update-collapse__title {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ── Footer actions (móvil) ───────────────────────────────────── */
.update-footer-actions {
  display: none;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 4px;
}

@media (max-width: 640px) {
  .update-topbar__actions {
    display: none;
  }
  .update-footer-actions {
    display: flex;
  }
  .update-fields-grid {
    grid-template-columns: 1fr;
  }
}
</style>
